export const createConversationLoadGuard = () => {
  let currentGeneration = 0;

  return {
    begin(conversationId) {
      currentGeneration += 1;
      return {
        conversationId: Number(conversationId),
        generation: currentGeneration,
      };
    },

    isCurrent(request, conversationId = request?.conversationId) {
      return (
        !!request &&
        request.generation === currentGeneration &&
        Number(request.conversationId) === Number(conversationId)
      );
    },

    invalidate() {
      currentGeneration += 1;
    },
  };
};

export const shouldPreviewConversation = ({
  embedded,
  currentConversationId,
  targetConversationId,
}) =>
  !embedded &&
  Number(currentConversationId || 0) !== Number(targetConversationId || 0);

export const isConversationHydrated = ({
  conversationId,
  currentChat,
  loadState,
}) =>
  loadState === 'ready' &&
  Number(conversationId || 0) > 0 &&
  Number(currentChat?.id || 0) === Number(conversationId) &&
  currentChat?.dataFetched === true;
